/**
 * Copy text to clipboard with HTTP/HTTPS compatibility
 * Uses navigator.clipboard API when available (HTTPS), falls back to execCommand (HTTP)
 * @param {string} text - Text to copy
 * @returns {Promise<void>}
 */
export function copyToClipboard(text) {
  // Modern API - only works on HTTPS
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  }

  // Fallback for HTTP using execCommand
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0;';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  try {
    const success = document.execCommand('copy');
    document.body.removeChild(textarea);
    if (!success) {
      return Promise.reject(new Error('execCommand failed'));
    }
    return Promise.resolve();
  } catch (err) {
    document.body.removeChild(textarea);
    return Promise.reject(err);
  }
}

/**
 * Initialize copy button functionality
 * Attaches click handlers to elements with data-copy attribute
 */
export function initCopyButtons() {
  const copyButtons = document.querySelectorAll('[data-copy]');

  copyButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const textToCopy = button.dataset.copy || window.location.href;

      copyToClipboard(textToCopy)
        .then(() => {
          // Show success feedback
          const originalText = button.getAttribute('aria-label');
          button.setAttribute('aria-label', 'コピーしました');
          button.classList.add('is-copied');

          setTimeout(() => {
            button.setAttribute('aria-label', originalText);
            button.classList.remove('is-copied');
          }, 2000);
        })
        .catch(() => {
          // Show failure feedback
          alert('コピーに失敗しました。URLを手動でコピーしてください。\n\n' + textToCopy);
        });
    });
  });
}
